/**
 * Showcase Mode - hidden demo environment activated by typing "demotime"
 * on the login page. Seeds the OfflineStore with fictional Fernbrook Ltd
 * data and sets a fake auth token so the app runs entirely offline.
 */

import { OfflineStore } from './offline-store'
import { SyncQueue } from './sync-queue'
import { seedShowcaseCache } from './showcase-fixtures'

const SHOWCASE_KEY = 'ledger:showcase'
const TOKEN_KEY = 'ledger_core_token'
const SHOWCASE_TOKEN = 'showcase-token'

export function isShowcaseMode(): boolean {
  try {
    return sessionStorage.getItem(SHOWCASE_KEY) === '1'
  } catch {
    return false
  }
}

export function activateShowcase(): void {
  sessionStorage.setItem(SHOWCASE_KEY, '1')

  // Seed the offline cache with fixture data
  const store = new OfflineStore()
  seedShowcaseCache(store)

  // Set a fake auth token so the app considers us authenticated
  localStorage.setItem(TOKEN_KEY, SHOWCASE_TOKEN)

  // Reload to enter the app in showcase mode
  window.location.reload()
}

export function deactivateShowcase(): void {
  // Tear down all showcase state
  const store = new OfflineStore()
  store.clearCache()

  const queue = new SyncQueue()
  queue.clear()

  sessionStorage.removeItem(SHOWCASE_KEY)
  localStorage.removeItem(TOKEN_KEY)

  // Reload back to login
  window.location.reload()
}
